// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quotePageStyle_previewImage__v4wYh {
  width: 150px;
  display: inline-block;
  background-color: #ccc;
}

@media screen and (max-width: 1000px) {
  .quotePageStyle_previewImage__v4wYh {
    height: 36px;
    width: 54px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Styles/quotePageStyle.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".previewImage {\n  width: 150px;\n  display: inline-block;\n  background-color: #ccc;\n}\n\n@media screen and (max-width: 1000px) {\n  .previewImage {\n    height: 36px;\n    width: 54px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewImage": `quotePageStyle_previewImage__v4wYh`
};
export default ___CSS_LOADER_EXPORT___;
